export const notNullish = (val) => val != null;
